import React from "react";
import TableView from "../tables/TableView";
import AddNewButton from "../buttons/AddNewButton";
import useTableData from "./useTableData";
import ListViewCommon from "./ListViewCommon";

const headers = [
    {"label": "username", "caption": "Užívateľ"},
    {"label": "first_name", "caption": "Meno"},
    {"label": "last_name", "caption": "Priezvisko"},
    {"label": "email", "caption": "E-mail"},
    {"label": "is_staff", "caption": "Admin"},

]

function Users(props) {
    const baseUrl = '/users'
    const initialFilters = []
    const[data, filters, filterUpdate, links, delete_single] = useTableData(baseUrl, initialFilters, parse_links)

    function parse_links(data) {
        return data.map(entry => ({
            'username': `/users/user/${entry.id}`
        }))
    }

    return (
        <ListViewCommon baseUrlFrontend={`/users/user`}
            // filters={filters}
            // filterUpdate={filterUpdate}
                        links={links}
                        headers={headers}
                        data={data}
                        delete_single={delete_single}
                        label={"Správa užívateľov"}
        />
        // <div>
        //     <TableView links={links} headers={headers} data={data} delete_single={delete_single} label="Zoznam užívateľov"/>
        //     <AddNewButton link={`/users/user/new`}/>
        // </div>
    )
}

export default Users
